import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import TestClass from '../sections/TestClass'

const TestPage = () => {
  return (
    <div className='__page-container'>
      <Navbar />
      <div className='__container'>
        <TestClass />
      </div> 
      <Footer />
    </div>
  )
}

export default TestPage